import { useState, useEffect } from 'react';


export const useScroll = (): number => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollY;
};


export const useMobileMenu = (): { isOpen: boolean; open: () => void; close: () => void; toggle: () => void } => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(!isOpen);

  return { isOpen, open, close, toggle };
};


export { useServiceSearch } from './useServiceSearch';
export { useTheme } from './useTheme';
